import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const CreateRoleDtoSchema = z.object({
  name: z.string(),
});

const CreateRoleResponseDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  organizationId: z.string().nullable(),
});

export type CreateRoleRequestDto = z.infer<typeof CreateRoleDtoSchema>;
export type CreateRoleResponseDto = z.infer<typeof CreateRoleResponseDtoSchema>;

export const createRole = (
  dto: CreateRoleRequestDto,
  config?: AxiosRequestConfig<CreateRoleRequestDto>
) => {
  const { ...data } = CreateRoleDtoSchema.parse(dto);
  return api
    .post(`/roles/`, data, config)
    .then(responseContract(CreateRoleResponseDtoSchema));
};
